{
  "back": "Back",
  "begin": "Begin",
  "codeCreatedToast": "Code Created",
  "codeExpiresWithExpirationDate": "Code Expires: {{expirationDate, datetime}}",
  "codeWillBeOverwrittenWarningWithCodeString": "Your farm's existing code ({{codeString}}) will be overwritten and no longer usable.",
  "contineToDevicePermissions": "Next: Device Permissions",
  "continueToFarmPermissions": "Next: Farm Permissions",
  "continueToReviewChoices": "Next: Review Choices",
  "done": "Done",
  "previewText": "Farm Join codes are 6-digit randomly-generated codes which allow new users to join a farm account. When the user joins, they will start with permissions specified by the farm.\n\nTo create a code for your farm, you will perform the following steps:",
  "reviewChoicesPreviewText": "Review your choices, then click 'submit' to generate the new code.",
  "reviewChoicesStageDescription": "Click 'submit' to generate the new code.",
  "reviewChoicesStageTitle": "Review Choices",
  "reviewChoicesTitle": "Review Choices",
  "setDevicePermissionsPreviewText": "Set initial device permissions for users who join with the code.",
  "setDevicePermissionsStageDescription": "Upon joining the farm, users will have the following permissions for devices in the farm.",
  "setDevicePermissionsStageTitle": "Set Device Permissions",
  "setFarmPermissionsPreviewText": "Set initial farm permissions for users who join with the code.",
  "setFarmPermissionsStageDescription": "Upon joining the farm, users will have the following permissions for managing the farm account.",
  "setFarmPermissionsStageTitle": "Set Farm Permissions",
  "shareYourCodeTitle": "Share Your Code",
  "stepWithStepNumber": "Step {{stepNumber}}: ",
  "successDescription": "Share the code with users who you want to join your farm. They will enter the code and become linked to your farm account.\n\nThey will start with the permissions you specified, but you can change these permissions later.",
  "successPreviewText": "Share the code with users who you want to join your farm. They will enter the code and become linked to your farm account.",
  "yourCode": "Your Code: ",
  "yourCodeWasCreatedSuccessfully.": "Your code was created successfully."
}
